import { ModalArea } from '../../common/ModalButtonArea';
import {
  GAMIFIED_STEPS,
  gamifyBoardingActions,
  selectFinalProgressStage,
  selectIsFinalProgress,
  STAGE,
} from '../../redux/slicers/gamifySlicer';
import styles from './FinalProgressModal.module.scss';
import ElectricIcon from '../../assets/images/light.png';
import RocketIcon from '../../assets/images/rocket.png';
import { useDispatch, useSelector } from 'react-redux';
import { ProgressBarLine } from '../gamificationTooltip/gamificationTooltip';
import { useUserContext } from '../../contexts/UserContext';
import { useEffect } from 'react';
import { wait } from '../../helpers/jsHelper';

const ProgressUI = ({ title, description, iconImg, belowDescription, progress }) => {
  return (
    <div className={styles.container}>
      <div className={styles.topRow}>
        <div className={styles.innerRow}>
          <h2>{title}</h2>
          <p>{description}</p>
          <ProgressBarLine className={styles.progressLine} progress={progress} />
        </div>
      </div>
      <div className={styles.bottomRow}>
        <img src={iconImg} width="14px" />
        <p>{belowDescription}</p>
      </div>
    </div>
  );
};

const FinalProgressModal = () => {
  const dispatch = useDispatch();
  const isActive = useSelector(selectIsFinalProgress);
  const stage = useSelector(selectFinalProgressStage);
  const { currentUser } = useUserContext();
  const firstName = currentUser?.user?.first_name;

  useEffect(() => {
    if(stage === STAGE.BEGIN) return;
    
    const urlParams = new URLSearchParams(window.location.search);
    const isOnboarding = urlParams.get('isOnboarding') || false;

    const timer = setTimeout(async () => {
      if(isOnboarding === true || isOnboarding === 'true') {
        dispatch(gamifyBoardingActions.setFinalProgress(false));
      }
    }, 3000);

    return () => clearTimeout(timer);

  }, [stage])

  if (!isActive) return null;

  const progressData =
    stage === STAGE.BEGIN
      ? {
          title: `Nice work, ${firstName}!`,
          description: 'Get ready, your first image is about to appear any second now.',
          iconImg: ElectricIcon,
          belowDescription: 'Lightning fast delivery enabled. Enjoy this pro feature!',
          progress: 25,
        }
      : {
          title: 'It’s almost ready',
          description: 'We’re just adding the finishing touches.',
          iconImg: RocketIcon,
          belowDescription: 'You won’t find renders this fast anywhere else.',
          progress: 75,
        };

  return (
    <ModalArea
      showModal={Boolean(isActive)}
      className={styles.model}
      size="lg"
      centered={true}
      animation
      backdropClassName={stage === STAGE.FINAL ? styles.blurredBackup : ''}
      hideCloseButton={true}
      body={
        <>
          <ProgressUI {...progressData} />
        </>
      }
    />
  );
};

export default FinalProgressModal;
